import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook } from "lucide-react";
import { FACEBOOK_URL, CTA_DEVIS } from "@/data/forms";

const linkCls = "text-gray-300 hover:text-white transition-colors text-sm";

export default function Footer() {
  return (
    <footer data-testid="main-footer" className="bg-[#0a0a0a] border-t border-[#333]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <div className="mb-6">
              <img src="/logo-blanc.webp" width="107" height="60" alt="VGI Construct" className="h-[60px] w-auto" loading="lazy" />
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-3">
              VGI Construct SRL, entreprise générale de rénovation créée en 2018, active à Bruxelles et dans tout le Brabant.
            </p>
            <p className="text-gray-400 text-xs mb-4">BCE/TVA : BE 0705.849.204</p>
            <Link to="/zones-intervention" data-testid="footer-zones-link" className="inline-block text-gray-200 text-sm font-semibold hover:text-white hover:underline">
              Bruxelles | Brabant flamand | Brabant wallon
            </Link>
            <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Page Facebook VGI Construct"
              className="mt-5 inline-flex items-center gap-2 text-gray-200 hover:text-white text-sm font-semibold transition-colors">
              <span className="w-9 h-9 rounded-full bg-[#1877F2] flex items-center justify-center"><Facebook size={18} color="#fff" fill="#fff" /></span>
              Suivez-nous sur Facebook
            </a>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Navigation</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/" className={linkCls}>Accueil</Link>
              <Link to="/a-propos" className={linkCls}>À propos</Link>
              <Link to="/services" className={linkCls}>Services</Link>
              <Link to="/realisations" className={linkCls}>Réalisations</Link>
              <Link to="/notre-processus" className={linkCls}>Comment ça marche</Link>
              <Link to="/contact" className={linkCls}>Contact</Link>
              <Link to="/demande-devis" data-testid="footer-cta" className="text-white hover:underline text-sm font-semibold">{CTA_DEVIS}</Link>
            </nav>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Nos zones</h4>
            <nav className="flex flex-col gap-3">
              <Link to="/travaux-ixelles" className={linkCls}>Ixelles</Link>
              <Link to="/travaux-uccle" className={linkCls}>Uccle</Link>
              <Link to="/travaux-anderlecht" className={linkCls}>Anderlecht</Link>
              <Link to="/travaux-waterloo" className={linkCls}>Waterloo</Link>
              <Link to="/travaux-wavre" className={linkCls}>Wavre</Link>
              <Link to="/travaux-vilvorde" className={linkCls}>Vilvorde</Link>
              <Link to="/travaux-schaerbeek" className={linkCls}>Schaerbeek</Link>
              <Link to="/zones-intervention" className="text-gray-200 hover:text-white hover:underline transition-colors text-sm font-semibold">Voir toutes les zones →</Link>
            </nav>
          </div>
          <div>
            <h4 className="text-white font-bold text-sm uppercase tracking-wider mb-6" style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}>Contact</h4>
            <div className="flex flex-col gap-4">
              <a href="tel:+32466407988" className={`flex items-center gap-3 ${linkCls}`}>
                <Phone size={16} className="text-gray-400 flex-shrink-0" /> +32 466 407 988
              </a>
              <a href="mailto:info@vgiconstruct.be" className={`flex items-center gap-3 ${linkCls}`}>
                <Mail size={16} className="text-gray-400 flex-shrink-0" /> info@vgiconstruct.be
              </a>
              <div className="flex items-start gap-3 text-gray-300 text-sm">
                <MapPin size={16} className="text-gray-400 flex-shrink-0 mt-0.5" />
                <span>Bergensesteenweg 24/8,<br/>1600 Sint-Pieters-Leeuw</span>
              </div>
              <div className="flex items-start gap-3 text-gray-300 text-sm">
                <Clock size={16} className="text-gray-400 flex-shrink-0 mt-0.5" />
                <span>Lun–ven : 8h–18h<br/>Urgences dépannage 7j/7</span>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-[#333] mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-center sm:text-left">
          <p className="text-gray-400 text-xs">&copy; {new Date().getFullYear()} VGI Construct SRL. Tous droits réservés. BCE/TVA : BE 0705.849.204</p>
          <div className="flex items-center gap-4">
            <Link to="/mentions-legales" className="text-gray-400 hover:text-white text-xs transition-colors">Mentions légales & Confidentialité</Link>
            <span className="text-gray-600">|</span>
            <Link to="/zones-intervention" className="text-gray-400 hover:text-white text-xs transition-colors">Zones d'intervention</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
